import React from 'react';
import { Tooltip } from '@components/common';
import { Button } from 'react-bootstrap';

const staffColumns = (totalCount, editMember, resetPassword, deleteStaff) => ([
	{
		property : 'id',
		header   : {
			label : 'ID',
			props : {
				className : 'col-sm-1',
			},
		},
		cell : {
			formatters : [(value) => value],
		},
	},
	{
		property : 'name',
		header   : {
			formatters : [
				() => (
					<div>
						Name
						<span className="summary">
							{' '}
							(
							{ totalCount }
							)
						</span>
					</div>
				),
			],
			props : {
				className : 'col-sm-3',
			},
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<button className="btn btn-link name" type="button" onClick={editMember(rowData.id)} onKeyPress={null}>
						<span>
							{ value.firstName }
							{' '}
						</span>
						<span>{ value.lastName }</span>
					</button>
				),
			],
		},
	},
	{
		property : 'phone',
		header   : {
			label : 'Phone',
			props : {
				className : 'col-sm-2',
			},
		},
		cell : {
			formatters : [(value) => value],
		},
	},
	{
		property : 'email',
		header   : {
			label : 'Email',
			props : {
				className : 'col-sm-3',
			},
		},
		cell : {
			formatters : [(value) => value],
		},
	},
	{
		header : {
			label : 'Actions',
			props : {
				className : 'col-sm-3',
			},
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<div>
						<Button
							className="margin-right-4"
							onClick={resetPassword(rowData.email, rowData.name.firstName)}
						>
							Reset Password
						</Button>
						<Tooltip content="Edit">
							<Button
								className="btn-icon-only height-34 margin-right-4"
								id={`edit-staff-${rowData.id}`}
								onClick={editMember(rowData.id)}
							>
								<i className="rkf rkf-pencil" />
							</Button>
						</Tooltip>
						<Tooltip content="Delete">
							<Button
								className="btn-icon-only height-34"
								id={`delete-staff-${rowData.id}`}
								onClick={deleteStaff(rowData.id)}
							>
								<i className="rkf rkf-trash" />
							</Button>
						</Tooltip>
					</div>
				),
			],
		},
	},
]);

export default staffColumns;
